import React, { FC } from 'react';

import { Flex, Layout, Row, Space, Table, theme, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { NSKeys } from '@app/i18n';

import { useLocalSelector } from '@app/services/hooks/useRedux';
import { useTableParams } from '@app/services/hooks/useTableParams';

import { useGetProjectsQuery } from '../../hooks';

import { AddProject } from './components/AddProject';
import { ListTypeSwitch } from './components/ListTypeSwitch';
import { TableActionMenu } from './components/TableActionMenu';
import { getBaseColumns } from './data/constants';

import { ListType } from './interfaces';
import { Container } from './styles';

export const List: FC = () => {
  const navigate = useNavigate();
  const commonT = useTranslation(NSKeys.common);
  const projectsT = useTranslation(NSKeys.projects);
  const [searchParams] = useSearchParams();
  const viewType = searchParams.get('view');
  const currentSession = useLocalSelector((state) => state.currentSession);
  const { current, pageSize, setPagination, resetParams } = useTableParams();
  const { data, isLoading } = useGetProjectsQuery({
    offset: (current - 1) * pageSize,
    limit: pageSize,
    process_uid: '',
    is_archived: viewType === ListType.ARCHIVED,
  });
  const { token } = theme.useToken();

  const COLUMNS = getBaseColumns(token.colorPrimaryBg);

  return (
    <>
      <Layout.Header>
        <Row justify="space-between" align="middle">
          <Flex gap={10} align="center">
            <Typography.Title level={2} className="title" style={{ marginBottom: 0 }}>
              {projectsT.t('title')}
            </Typography.Title>

            <ListTypeSwitch />
          </Flex>
          {currentSession?.ordersContext?.scope?.$permissions?.create_projects && (
            <Space size="middle">
              <AddProject />
            </Space>
          )}
        </Row>
      </Layout.Header>

      <Container>
        <Table
          loading={isLoading}
          dataSource={data?.items || []}
          rowKey="uid"
          className="tableClassname"
          style={{ marginTop: 24 }}
          onRow={(data) => {
            return {
              onClick: () => navigate(`${data.uid}`),
            };
          }}
          rowClassName="cursorPointer"
          columns={[
            ...COLUMNS.map((el) => ({ ...el, title: projectsT.t(el.title as any) })),
            {
              key: 'action',
              width: 60,
              fixed: 'right',
              onCell: () => {
                return {
                  onClick: (e) => console.log(e.stopPropagation()),
                };
              },
              render: (_, cell) => cell?.$permissions?.manage && <TableActionMenu cell={cell} />,
            },
          ]}
          key="uid"
          pagination={{
            current: current,
            pageSize: pageSize,
            total: data?.total,
            showQuickJumper: true,
            showSizeChanger: true,
            position: ['bottomCenter'],
            onChange: (newPage, newSize) => {
              setPagination(newPage, newSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} ${commonT.t('paginationOf')} ${total}`,
          }}
          scroll={{ x: true }}
        />
      </Container>
    </>
  );
};
